import ListProducers from "@/views/organization/partners/producers/ListProducers.vue";
import ListProducersFormalizedActive from "@/components/views/organization/partners/producers/ListProducersFormalizedActive.vue";
import ListProducersNotFormalizedActive from "@/components/views/organization/partners/producers/ListProducersNotFormalizedActive.vue";
import ListProducersInactive from "@/components/views/organization/partners/producers/ListProducersInactive.vue";
import ShowProducer from "@/views/organization/partners/producers/ShowProducer.vue";
import NewProducer from "@/views/organization/partners/producers/NewProducer.vue";
import EditProducer from "@/views/organization/partners/producers/EditProducer.vue";
import NewCropField from "@/views/organization/partners/producers/NewCropField.vue";
import EditCropField from "@/views/organization/partners/producers/EditCropField.vue";


import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "partners",
  permission: "producers"
});

export default [
  {
    path: "/org/:organization_id/partners/producers/list",
    name: routeName(""),
    redirect: { name: routeName("list_producers") }
  },
  {
    path: "/org/:organization_id/partners/producers/list",
    name: routeName("list_producers"),
    redirect: { name: routeName("list_producers_formalized_active") },
    component: ListProducers,
    props: true,
    meta: META,
    children: [
      {
        path: "formalized_active",
        name: routeName("list_producers_formalized_active"),
        alias: "",
        component: ListProducersFormalizedActive,
        props: true
      },
      {
        path: "not_formalized_active",
        name: routeName("list_producers_not_formalized_active"),
        component: ListProducersNotFormalizedActive,
        props: true
      },
      {
        path: "inactive",
        name: routeName("list_producers_inactive"),
        component: ListProducersInactive,
        props: true
      }
    ]
  },
  {
    path: "/org/:organization_id/partners/producers/:producer_id/show",
    name: routeName("show_producer"),
    component: ShowProducer,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/partners/producers/new",
    name: routeName("new_producer"),
    component: NewProducer,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/partners/producers/:producer_id/edit",
    name: routeName("edit_producer"),
    component: EditProducer,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/partners/producers/:producer_id/new_crop_field",
    name: routeName("new_crop_field"),
    component: NewCropField,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/partners/producers/:producer_id/edit_crop_field/:crop_field_id",
    name: routeName("edit_crop_field"),
    component: EditCropField,
    props: true,
    meta: META
  }
];
